"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = __importDefault(require("./state"));
var profile_container_1 = __importDefault(require("../views/profile-container"));
var navigation_button_1 = __importStar(require("../views/navigation-button"));
var title_container_1 = __importDefault(require("../views/title-container"));
var stat_container_1 = __importDefault(require("../views/stat-container"));
var game_area_1 = require("../utilities/game-area");
var stack_container_1 = __importStar(require("../views/stack-container"));
var profile_1 = __importDefault(require("../models/profile"));
var i18next_1 = __importDefault(require("i18next"));
var send_state_1 = __importDefault(require("./send-state"));
var name_container_1 = __importDefault(require("../views/name-container"));
var calculator_1 = __importStar(require("../models/calculator"));
var PROFILE_STATS_ROWS = 4;
var PROFILE_STATS_COLUMNS = 2;
var PROFILE_STATS_COUNT = PROFILE_STATS_ROWS * PROFILE_STATS_COLUMNS;
var ProfileState = /** @class */ (function (_super) {
    __extends(ProfileState, _super);
    function ProfileState(app, client) {
        var _this = _super.call(this) || this;
        _this._app = app;
        _this._client = client;
        return _this;
    }
    Object.defineProperty(ProfileState.prototype, "profileContainer", {
        get: function () {
            if (!this._profileContainer) {
                this._profileContainer = new profile_container_1.default(this._app.loader.resources);
                this._profileContainer.scale.set(0.5);
                this._profileContainer.position.set(game_area_1.GAME_WIDTH * 0.5, game_area_1.GAME_HEIGHT * 0.5);
            }
            return this._profileContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProfileState.prototype, "backButton", {
        get: function () {
            var _this = this;
            if (!this._backButton) {
                this._backButton = new navigation_button_1.default(this._app.loader.resources.ui.textures, navigation_button_1.NAVIGATION_BUTTON_TYPE.BACK, function () {
                    _this.stateMachine.pop();
                });
                this._backButton.position.set(game_area_1.GAME_SAFE_AREA.left + 12, game_area_1.GAME_SAFE_AREA.top + 12);
            }
            return this._backButton;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProfileState.prototype, "titleContainer", {
        get: function () {
            if (!this._titleContainer) {
                this._titleContainer = new title_container_1.default(this._app.loader.resources.ui.textures);
                this._titleContainer.setText(i18next_1.default.t("profile_title"));
                this._titleContainer.position.set((game_area_1.GAME_WIDTH - this._titleContainer.width) * 0.5, game_area_1.GAME_SAFE_AREA.top + 12);
            }
            return this._titleContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProfileState.prototype, "sendButton", {
        get: function () {
            var _this = this;
            if (!this._sendButton) {
                this._sendButton = new navigation_button_1.default(this._app.loader.resources.ui.textures, navigation_button_1.NAVIGATION_BUTTON_TYPE.SEND, function () {
                    _this.stateMachine.push(send_state_1.default, function (state) {
                        state.dragonContainer = _this.dragonContainer;
                        state.dragon = _this.dragon;
                    });
                });
                this._sendButton.position.set(game_area_1.GAME_SAFE_AREA.right - this._sendButton.width - 12, game_area_1.GAME_SAFE_AREA.top + 12);
            }
            return this._sendButton;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProfileState.prototype, "nameContainer", {
        get: function () {
            if (!this._nameContainer) {
                this._nameContainer = new name_container_1.default(this._app.loader.resources.ui.textures);
                this._nameContainer.maxGems = calculator_1.default.evolutions(calculator_1.MAX_STAGE);
            }
            return this._nameContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProfileState.prototype, "statContainers", {
        get: function () {
            if (!this._statContainers) {
                this._statContainers = [];
                var statWidth = game_area_1.GAME_SAFE_AREA.width / PROFILE_STATS_COLUMNS;
                for (var i = 0; i < PROFILE_STATS_COUNT; i++) {
                    var statContainer = new stat_container_1.default(statWidth);
                    this._statContainers.push(statContainer);
                }
            }
            return this._statContainers;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProfileState.prototype, "stackContainer", {
        get: function () {
            if (!this._stackContainer) {
                this._stackContainer = stack_container_1.default.Group(this.statContainers, PROFILE_STATS_COLUMNS, {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.HORIZONTAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: 0
                }, {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.VERTICAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: 16
                });
                this._stackContainer.position.set(game_area_1.GAME_SAFE_AREA.left, game_area_1.GAME_SAFE_AREA.bottom - this._stackContainer.height - 10);
            }
            return this._stackContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProfileState.prototype, "dragonContainer", {
        get: function () {
            return this._dragonContainer;
        },
        set: function (value) {
            this._dragonContainer = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProfileState.prototype, "dragon", {
        get: function () {
            return this._dragon;
        },
        set: function (value) {
            this._dragon = value;
        },
        enumerable: false,
        configurable: true
    });
    ProfileState.prototype.didEnterFrom = function (previousState) {
        _super.prototype.didEnterFrom.call(this, previousState);
        this._app.stage.addChild(this.profileContainer);
        this._app.stage.addChild(this.backButton);
        this._app.stage.addChild(this.titleContainer);
        this._app.stage.addChild(this.sendButton);
        this._app.stage.addChild(this.nameContainer);
        this._app.stage.addChild(this.stackContainer);
        this.dragonContainer.setIdleAnimation();
        this.profileContainer.dragonSlot.addChild(this.dragonContainer);
        this.sendButton.visible = this.dragon != this._client.dragon;
        var dragonPosition = this._app.stage.toLocal(this.dragonContainer.position, this.dragonContainer);
        this.nameContainer.setTitle(this.dragon.status.name, true, calculator_1.default.evolutions(this.dragon.status.stage));
        this.nameContainer.position.set(dragonPosition.x - (this.nameContainer.width * 0.5), dragonPosition.y + 16);
        this.updateStats();
        this._client.sendEvent("profile_entered", {
            dragon: this.dragon
        });
    };
    ProfileState.prototype.willExitTo = function (nextState) {
        _super.prototype.willExitTo.call(this, nextState);
        this._app.stage.removeChild(this.profileContainer);
        this._app.stage.removeChild(this.backButton);
        this._app.stage.removeChild(this.titleContainer);
        this._app.stage.removeChild(this.sendButton);
        this._app.stage.removeChild(this.nameContainer);
        this._app.stage.removeChild(this.stackContainer);
        this.profileContainer.dragonSlot.removeChild(this.dragonContainer);
    };
    ProfileState.prototype.updateStats = function () {
        var stats = profile_1.default.Stats(this.dragon);
        for (var i = 0; i < this.statContainers.length; i++) {
            var statContainer = this.statContainers[i];
            if (i >= stats.length) {
                statContainer.setTitle(null, null);
                continue;
            }
            var stat = stats[i];
            statContainer.setTitle(stat.title, stat.value);
        }
    };
    return ProfileState;
}(state_1.default));
exports.default = ProfileState;
